// extracted by mini-css-extract-plugin
module.exports = {"button":"BaseButton_button_1QOeP"};